const HotelData = [
	{
		id: 1,
		name: 'Rose View',
		description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Autem, ipsam',
		image: 'https://media-cdn.tripadvisor.com/media/photo-s/11/01/59/80/view-from-outside.jpg',
		location: 'jaflong',
	},
	{
		id: 2,
		name: 'Hotel Noorjahan',
		description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Autem, ipsam',
		image: 'https://pix10.agoda.net/hotelImages/2155644/-1/04ebfef371750e694360a496436f230c.jpg?s=1024x768',
		location: 'jaflong',
	},
	{
		id: 3,
		name: 'Hotel Supreme',
		description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Autem, ipsam',
		image: 'https://pix10.agoda.net/hotelImages/70754/-1/3a05e06a241172615e63df0b410afc44.jpg?s=1024x768',
		location: 'jaflong',
	},
	{
		id: 4,
		name: 'Hotel SundorBand',
		description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Autem, ipsam',
		image:
			'https://thumbnails.trvl-media.com/5BdFjI6Z-rIVTBvBqcx1yrjTZDU=/500x333/smart/filters:quality(80)/images.trvl-media.com/hotels/49000000/48610000/48601700/48601647/6b877d4b_z.jpg',
		location: 'SundarBan',
	},
	{
		id: 5,
		name: 'Near SundarBan',
		description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Autem, ipsam',
		image: 'https://s3-ap-southeast-1.amazonaws.com/cdn.bindu365.com/property/619/images/619_images0_1574834187.jpg',
		location: 'SundarBan',
	},
	{
		id: 6,
		name: 'Perfect View',
		description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Autem, ipsam',
		image: 'https://pix10.agoda.net/hotelImages/7948676/-1/65a3599be85e0a091f1fe63cfe187634.jpg?s=1200x800',
		location: 'SundarBan',
	},
	{
		id: 7,
		name: 'Saint Martin Hotel',
		description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Autem, ipsam',
		image: 'https://i.pinimg.com/originals/38/71/3c/38713cb7dbded4a08cd74636ff8ada20.jpg',
		location: 'Saint Martin',
	},
	{
		id: 8,
		name: 'Hotel Darucini',
		description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Autem, ipsam',
		image: 'https://media-cdn.tripadvisor.com/media/photo-s/06/bb/0b/b0/hotel-saint-martin-limited.jpg',
		location: 'Saint Martin',
	},
	{
		id: 9,
		name: 'Hotel Garden',
		description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Autem, ipsam',
		image: 'https://www.qualitygroupmare.it/sites/default/files/hotels/promo_images/las-ext-sce-23_bis.jpg',
		location: 'Saint Martin',
	},
];
export default HotelData;
